import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AuthService } from './auth.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Addon } from '../classes/addon';
import { Project } from '../classes/project';
import { Subject } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { of } from 'rxjs/observable/of';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class AddonManagerService {
  private cmsURL: string = environment.newCms3Url;
  // private URL: string = environment.appUrl;
  private URL: string = environment.apiUrl;
  // private URL = 'http://localhost:9000/api/';
  addonProject: Addon = new Addon();
  project: Project = new Project();
  // project: any = {};
  projectId: string = '';

  isSavedProject = new BehaviorSubject<boolean>(false);

  projectNewChanges = new Subject<string>();

  sharedProjId: string = null;

  constructor(private http: HttpClient, private auth: AuthService) {}

  private handleError(error: HttpErrorResponse, errorMessage: string) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,

      if (error instanceof Array) {
        // handle class-validator errors
        error.forEach(err => {
          const obj = err.constraints;
          if (obj) {
            for (const prop in obj) {
              if (obj.hasOwnProperty(prop)) {
                console.error('Backend error: ' + obj[prop]);
              }
            }
          }
        });
      } else if (typeof error === 'string') {
        console.error(`Backend returned message: ${error}`);
      } else console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return ErrorObservable.create(errorMessage);
  }

  getDataFromCms(): Observable<any> {
    return this.http.get<any[]>(`${this.cmsURL}`, httpOptions);
  }

  getDataFromLocalJSON(): Observable<any> {
    return this.http.get<any>('assets/json/data_json.json', httpOptions);
  }

  getAddonProjects(userId?: string): Observable<any[]> {
    // const url = encodeURI(`${this.URL}/addons?filter={"where":{"userId":${userId}"}}`);
    const url = encodeURI(`${this.URL}/addons?filter[where][userId]=${userId}`);
    // const url = `${this.URL}/addons?filter=%7B%22where%22%3A%7B%22userId%22%3A%22string%22%7D%7D`;
    return this.http
      .get<any[]>(
        url,
        // `${this.URL}/addons/${userId}`,
        httpOptions
      )
      .pipe(
        map(data => {
          return data.sort((a, b) => {
            return new Date(b.updated).getTime() - new Date(a.updated).getTime();
          });
        })
      );
  }

  getAllAddonProjectsByUserId(userId?: string): Observable<any[]> {
    return this.http
      .get<any[]>(
        `${this.URL}/addons`,
        httpOptions
      )
      .pipe(
        map(data => {
          return data.filter(addon => addon.userId === userId).sort((a, b) => {
            return new Date(b.updated).getTime() - new Date(a.updated).getTime();
          });
        })
      );
  }

  getAllAddonProjects(): Observable<any[]> {
    return this.http
      .get<any[]>(
        `${this.URL}/addons`,
        httpOptions
      )
      .pipe(
        map(data => {
          return data.sort((a, b) => {
            return new Date(b.updated).getTime() - new Date(a.updated).getTime();
          });
        })
      );
  }

  getAddonProject(projectId: string): Observable<any> {
    return this.http.get(`${this.URL}/addons/${projectId}`, httpOptions);
  }

  resetAddonProject(): void {
    this.addonProject = new Addon();
    // this.addonProject.scenery = 'grid';
  }

  setAddonProject(proj: Addon) {
    this.addonProject = proj;
  }

  getCurrentAddonProject(): Addon {
    return this.addonProject;
  }

  // setTitleBlockOptions(options) {
  //   this.project.draw_options = {
  //     titleBlockOptions: options,
  //     items:
  //       this.project.draw_options && this.project.draw_options.items
  //         ? this.project.draw_options.items
  //         : {}
  //   };
  // }

  // setProToolsItems(items) {
  //   if (this.project.draw_options && this.project.draw_options.items !== null) {
  //     this.project.draw_options = {
  //       titleBlockOptions: this.project.draw_options.titleBlockOptions
  //         ? this.project.draw_options.titleBlockOptions
  //         : {},
  //       items: items
  //     };
  //   } else {
  //     this.project.draw_options = {
  //       titleBlockOptions: this.project.draw_options ? this.project.draw_options : {},
  //       items: items
  //     };
  //   }
  // }

  getCurrentAddonProjectId() {
    return this.addonProject.id;
  }

  // setIsSavedProject(value: boolean) {
  //   this.isSavedProject.next(value);
  // }

  setAddonProjectName(name: any) {
    this.addonProject.projectName = name;
  }

  setAddonProjectImg(img: any) {
    this.addonProject.projectImg = img;
  }

  // setTiers(tiers: Array<any>) {
  //   this.project.tiers = tiers;
  // }

  setAddonUserId(id: string) {
    this.addonProject.userId = id;
  }

  setAddonSnapshots(imgs: any) {
    this.addonProject.snapshots = imgs;
  }

  // setSnapshotsProTools(imgs: any) {
  //   this.project.snapshotsProTools = imgs;
  // }

  // setDeckHeight(value) {
  //   this.project.deckHeight = value;
  // }

  setAddonProjectType(value: string): void {
    this.addonProject.projectType = value;
    // this.projectNewChanges.next(value);
  }

  getAddonProjectType(): string {
    return this.addonProject.projectType;
  }

  saveAddonProject(): Observable<any> {
    const { id, ...project } = this.addonProject;
    return this.http.post(`${this.URL}/addons`, project, httpOptions).pipe(
      switchMap(res => {
        this.setAddonProject(<Addon>res);
        // this.setIsSavedProject(true);
        return of(res);
      }),
      catchError(err => {
        return this.handleError(err, 'Error saving project');
      })
    );
  }

  addonProjectExists(id: string): Observable<any> {
    return this.http.get(`${this.URL}/addons/${id}/exists`, httpOptions);
  }
  //
  // getAllUsersProjects(): Observable<any> {
  //   return this.http.get(`${this.URL}/projects`, httpOptions);
  // }
  //
  // getProject(projectId: string): Observable<any> {
  //   return this.http.get(`${this.URL}/projects/${projectId}`, httpOptions);
  // }
  //
  // updateProject(): Observable<any> {
  //   const { id, ...project } = this.project;
  //   return this.http
  //     .put(`${this.URL}/projects/${id}?access_token=${this.auth.getToken()}`, project, httpOptions)
  //     .pipe(catchError(err => this.handleError(err, 'Error updating project')));
  //   // return this.http.put(`${this.URL}/projects?access_token=${this.auth.getToken()}`, this.project, httpOptions);
  // }

  // projectNameValid(projectName: string): Observable<any> {
  //   return this.http
  //     .get(
  //       `${
  //         this.URL
  //       }/is-project-name-valid?project_name=${projectName}&user_id=${this.auth.getUserId()}`,
  //       httpOptions
  //     )
  //     .pipe(catchError(err => this.handleError(err, 'Error checking project name is unique')));
  // }
  //
  // getNewProjectName(): Observable<any> {
  //   return this.http
  //     .get(`${this.URL}/create-new-project-name?user_id=${this.auth.getUserId()}`, httpOptions)
  //     .pipe(
  //       switchMap(res => {
  //         return of((<any>res).projectName);
  //       }),
  //       catchError(err => {
  //         return this.handleError(err, 'Error getting new project name');
  //       })
  //     );
  // }
  //
  // updateProjectItem(projectId: any, property: string, value: any): Observable<any> {
  //   let obj = {};
  //   obj[property] = value;
  //   return this.http.patch(
  //     `${this.URL}/projects/${projectId}?access_token=${this.auth.getToken()}`,
  //     obj,
  //     httpOptions
  //   );
  // }

  // deleteAddonProject(projectId: any): Observable<any> {
  //   return this.http.delete(
  //     `${this.URL}/addons/${projectId}?access_token=${this.auth.getToken()}`,
  //     httpOptions
  //   );
  // }
  //
  // clearProject() {
  //   this.project = new Project();
  //   this.projectId = '';
  //   this.isSavedProject.next(false);
  // }
  //
  // getTemplates(): Observable<any> {
  //   return this.http.get(`${this.URL}/templates`, httpOptions);
  // }
  //
  // saveTemplate(): Observable<any> {
  //   const { id, ...project } = this.project;
  //   this.setIsSavedProject(true);
  //   return this.http.post(`${this.URL}/templates`, project, httpOptions);
  // }
  //
  // updateTemplate(): Observable<any> {
  //   const { id, ...project } = this.project;
  //   return this.http.put(
  //     `${this.URL}/templates/${id}?access_token=${this.auth.getToken()}`,
  //     project,
  //     httpOptions
  //   );
  // }
  //
  // updateTemplateItem(projectId: any, property: string, value: any): Observable<any> {
  //   let obj = {};
  //   obj[property] = value;
  //   return this.http.patch(
  //     `${this.URL}/templates/${projectId}?access_token=${this.auth.getToken()}`,
  //     obj,
  //     httpOptions
  //   );
  // }
  //
  // deleteTemplate(projectId: any): Observable<any> {
  //   return this.http.delete(
  //     `${this.URL}/templates/${projectId}?access_token=${this.auth.getToken()}`,
  //     httpOptions
  //   );
  // }
  //
  // setAccessories(accessories: Array<any>) {
  //   this.project.accessories = accessories;
  // }
  //
  // setDeckMaterial(texture: string) {
  //   this.project.deckMaterial = texture;
  // }
  //
  // getDeckMaterial(): string {
  //   return this.project.deckMaterial;
  // }
  //
  // setScenery(name: string) {
  //   this.project.scenery = name;
  // }
  //
  // getScenery() {
  //   return this.project.scenery;
  // }
  //
  // setRailing(railingParams: any) {
  //   this.project.railing = railingParams;
  // }
  //
  // setSharedProjID(id: string) {
  //   this.sharedProjId = id;
  // }
  //
  // ifCurrentProjIsSharedProj(id) {
  //   if (id === this.sharedProjId) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
}



// WEBPACK FOOTER //
// ./src/app/services/addon-manager.service.ts